<div class="star-rating">
  <a3l-ui-icon icon="star-fill" *ngFor="let star of stars"></a3l-ui-icon>
  <a3l-ui-icon icon="star-half" *ngIf="rating % 1 !== 0"></a3l-ui-icon>
  <a3l-ui-icon icon="star" *ngFor="let emptyStar of emptyStars"></a3l-ui-icon>
</div>
